import { createIcon } from '../icon'
import ShirtIcon from '../svg/ShirtIcon'

export const ShirtIconDefault = createIcon(ShirtIcon)
